var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9438 9.05957L17.5215 22.2149L10.4683 24.5659L6.92651 10.3987L10.9438 9.05957Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7394 30.6876L21.2817 23.7722L29.7008 20.9658L32.8072 25.8469L24.7394 30.6876Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4904 17.225L30.8328 17.7775L29.4518 15.6069L30.9886 15.2227L32.4904 17.225Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.66667C0 2.98477 2.98477 0 6.66667 0H33.3333C37.0152 0 40 2.98477 40 6.66667V33.3333C40 37.0152 37.0152 40 33.3333 40H6.66667C2.98477 40 0 37.0152 0 33.3333V6.66667ZM12.8119 6.8324C12.5151 6.23891 11.8271 5.95392 11.1977 6.16376L4.91195 8.25899C4.25099 8.47931 3.87107 9.17139 4.04005 9.84728L8.23053 26.6092C8.32061 26.9696 8.55688 27.276 8.88243 27.4547C9.208 27.6333 9.59336 27.6683 9.94568 27.5507L18.7262 24.6239L22.9982 33.1677C23.1642 33.5 23.4614 33.7477 23.8179 33.8517C24.1745 33.9555 24.5582 33.9059 24.8767 33.7149L35.3528 27.4291C35.6613 27.244 35.8819 26.9421 35.9645 26.5922C36.0472 26.2421 35.9848 25.8734 35.7917 25.57L32.3085 20.0964L35.0885 19.1698C35.4952 19.0342 35.8117 18.7115 35.9395 18.3024C36.0675 17.8933 35.9907 17.4477 35.7336 17.1049L32.5907 12.9144C32.2688 12.4852 31.7211 12.2907 31.2008 12.4209L27.0101 13.4685C26.5944 13.5724 26.2539 13.8699 26.0951 14.268C25.9363 14.6661 25.9786 15.1163 26.2087 15.4778L28.2253 18.6466L20.077 21.3627L12.8119 6.8324Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaravel);
export default __webpack_public_path__ + "static/media/laravel.27da47c3b398c449df39d18e3c5aa1b6.svg";
export { ForwardRef as ReactComponent };